export const CHART_COLORS = {
  // weight: '#e46e64',
  water: '#4fc3f7',
  // body_fat: '#757575',
  optimal_body_fat: '#b0bec5',
  bmi: '#317c71',
  der: '#fb8c00',
  bmr: '#f9b423',
  rmr: '#654337',
  hip: '#ba68c8',
  contour: '#ef78a1',
  waistline: '#dd5c60',
  carbohydrates: '#3eb8bb',
  lipids: '#fcb102',
  protein: '#f8395e',
  body_fat: '#e1e49d',
  muscles: '#c86361',
  residual_mass: '#c3e0f3',
  bones: '#AFAFAF',
  weight: '#A49CBA',
  btpm: '#c23632',
  brpm: '#2f4553',
  systolic: '#37A2DA',
  distolic: '#FBB7A1',
  glucose: '#E68CC2',
  temperature: '#00bcd4',
  height: '#4F4136',
  waist_hip: '#989C81',
  abdominal_diameter: '#4042A2',
};

export const BMI_COLORS = {
  under_weight: '#8694ce',
  healthy_weight: '#5cbaaf',
  over_weight_i: '#d1a864',
  over_weight_ii: '#a87d36',
  obesity_i: '#e46e64',
  obesity_ii: '#c2463c',
  severely_obese: '#9f261d',
  morbidly_obese: '#700049',
};



// WEBPACK FOOTER //
// ./src/constants/content-colors.js